import { PHONE, locationSchema } from "../structured-data-core";

export function getNoviStructuredData() {
  const url = "https://restorehair.com/locations/michigan/novi/";
  const description =
    "Find out about your hair transplant options in Novi with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Novi", "39555 Orchard Hill Place, Suite 600", "Novi", "MI", PHONE, url, description),
  ];
}
